import "./refer.css";
import React, { useState } from "react";
import {
  copyIcon,
  faceBookIcon,
  linkedInIcon,
  tickIcon,
  twitterIcon,
} from "../../../../components/expansion/Svg";
import Label from "../../../../components/Modules/Label";
import { PrimaryButton } from "../../../../components/Modules/PrimaryButton";
import QuestLabs from "../../../../components/QuestLabs";
import ReferEarnThemeManager from "./referEarnThemeManager";
import { QuestThemeData } from "../../Survey/modular/types";
import { Facebook, LinkedIn, Twitter } from "./SVG";
import { extractGradientColors } from "../../../../general";

interface OfflineReferEarnProps {
  referralCode: string;
  heading?: string;
  description?: string;
  referralLink?: string;
  shareButtonText?: string;
  secondaryIconColor?: string;
  gradientBackground?: boolean;
  primaryHeading?: string;
  primaryDescription?: string;
  onCopy?: (referralCode: string) => void;
  showReferralCode?: boolean;
  showFooter?: boolean;
  gradientBackgroundColor?: string;
  styleConfig?: any;
  footerLink?: string;
  brandTheme?: any;
  QuestThemeData?: QuestThemeData;
  showReferralLogo?: boolean;
  themeConfig?: any;
}

const ReferIcon = ({ primary, secondary }: any) => {
  return <svg width="80" height="80" viewBox="0 0 80 80" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M72.4749 29.2978L42.2999 52.2728C40.9499 53.2978 39.0499 53.2978 37.6999 52.2728L7.5249 29.2978C7.7499 28.7728 8.1499 28.2978 8.6499 27.8978L37.7249 5.77282C38.3784 5.27407 39.1778 5.00391 39.9999 5.00391C40.822 5.00391 41.6214 5.27407 42.2749 5.77282L71.3499 27.8978C71.8499 28.2978 72.2499 28.7728 72.4749 29.2978Z" fill={primary || "#9035FF"} />
    <path d="M63.4749 16.4998V68.3498C63.4749 71.0748 61.2499 73.2748 58.5249 73.2748H21.4749C18.7499 73.2748 16.5249 71.0748 16.5249 68.3498V16.4998C16.5249 13.7748 18.7499 11.5498 21.4749 11.5498H58.5249C61.2499 11.5498 63.4749 13.7748 63.4749 16.4998Z" fill="white" />
    <path d="M63.4749 16.4998V20.2498C63.4749 17.5248 61.2499 15.2998 58.5249 15.2998H21.4749C18.7499 15.2998 16.5249 17.5248 16.5249 20.2498V16.4998C16.5249 13.7748 18.7499 11.5498 21.4749 11.5498H58.5249C61.2499 11.5498 63.4749 13.7748 63.4749 16.4998ZM63.4749 68.3498V72.0998C63.4749 74.8248 61.2499 77.0248 58.5249 77.0248H21.4749C18.7499 77.0248 16.5249 74.8248 16.5249 72.0998V68.3498C16.5249 71.0748 18.7499 73.2748 21.4749 73.2748H58.5249C61.2499 73.2748 63.4749 71.0748 63.4749 68.3498Z" fill="#EAEAEA" />
    <path d="M63.4749 31.4248V68.3498C63.4749 71.0748 61.2499 73.2748 58.5249 73.2748H21.4749C18.7499 73.2748 16.5249 71.0748 16.5249 68.3498V31.4248L39.9749 49.2998L63.4749 31.4248Z" fill="#EFEFEF" />
    <path d="M72.8499 30.8998V71.2248C72.8499 73.2998 71.1749 74.9998 69.0749 74.9998H10.9249C8.8249 74.9998 7.1499 73.2998 7.1499 71.2248V30.8998C7.1499 30.3248 7.2749 29.7748 7.5249 29.2998L37.6999 52.2748C39.0499 53.2998 40.9499 53.2998 42.2999 52.2748L65.0499 34.9498L72.4749 29.2998C72.7249 29.7748 72.8499 30.3248 72.8499 30.8998Z" fill={secondary || "#BF8AFF"} />
    <path d="M72.8501 30.8998V71.2248C72.8501 73.2998 71.1751 74.9998 69.0751 74.9998H57.3501C64.8501 59.4748 65.7751 44.9498 65.0501 34.9498L72.4751 29.2998C72.7251 29.7748 72.8501 30.3248 72.8501 30.8998Z" fill={primary || "#8634EA"} />
    <path d="M39.9998 39.9153C44.9123 39.1278 48.6173 36.0953 49.3048 32.3728C50.1923 27.5628 45.6998 21.7103 39.9998 26.4253C34.2998 21.7078 29.8073 27.5628 30.6948 32.3728C31.3823 36.0953 35.0873 39.1278 39.9998 39.9153Z" fill="#FE4F60" />
    <path d="M49.2999 32.3749C48.6249 36.0999 44.8999 39.1249 39.9999 39.9249C38.8999 39.7499 37.8499 39.4499 36.8999 39.0499C41.5249 37.5499 44.9249 34.5499 45.5249 31.1999C45.8499 29.3999 45.2999 27.1999 44.1749 25.8499C43.6749 25.2249 43.1749 24.9249 42.6749 24.9249C42.6499 24.9249 42.5999 24.9249 42.5499 24.9499C46.9749 23.4999 50.0499 28.3249 49.2999 32.3749Z" fill="#E54756" />
    <path d="M35.9 30.3179C36.2446 29.4149 36.1098 28.5249 35.599 28.33C35.0881 28.135 34.3947 28.7091 34.0501 29.612C33.7056 30.515 33.8404 31.4051 34.3512 31.6C34.8621 31.7949 35.5555 31.2209 35.9 30.3179Z" fill="#FF6D7A" />
  </svg>
}

export const OfflineReferEarnWrapper: React.FC<OfflineReferEarnProps> = ({
  referralCode,
  heading = "Referral link and code",
  description = "Share your unique referral code with friends and receive 10 coins in credits each time a friend signs up!",
  referralLink = "",
  shareButtonText = "Copy Referral Link",
  secondaryIconColor = "#939393",
  gradientBackground = false,
  primaryHeading = "Refer and earn!",
  primaryDescription = "Welcome back, Please complete your details",
  onCopy = (referralCode: string) => {},
  showReferralCode = true,
  showFooter = true,
  gradientBackgroundColor,
  styleConfig,
  footerLink,
  brandTheme,
  QuestThemeData,
  showReferralLogo = true,
  themeConfig,
}) => {
  const [copy, setCopy] = useState<boolean[]>([false, false]);

  const themeManager = React.useMemo(
    () =>
      new ReferEarnThemeManager(
        themeConfig,
        styleConfig,
        QuestThemeData,
        brandTheme
      ),
    [themeConfig, styleConfig, QuestThemeData, brandTheme]
  );

  const handleCopy = (index: number) => {
    const textToCopy = !index ? referralCode : referralLink + referralCode;
    navigator?.clipboard.writeText(textToCopy);

    setCopy((prev) => prev.map((e, i) => (i === index ? true : e)));
    setTimeout(() => {
      setCopy((prev) => prev.map((e, i) => (i === index ? false : e)));
    }, 3000);

    onCopy(textToCopy);
  };

  const handleSocialShare = (platform: "linkedin" | "facebook" | "x") => {
    const shareUrl = referralLink + referralCode;
    const urls = {
      linkedin: `https://www.linkedin.com/sharing/share-offsite/?url=${encodeURIComponent(shareUrl)}`,
      facebook: `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(shareUrl)}`,
      x: `https://twitter.com/intent/tweet?url=${encodeURIComponent(shareUrl)}`,
    };
    window.open(urls[platform], '_blank');
  };

  const renderReferralCodeSection = () => (
    <div className="q_refer_code_content">
      <Label children="Referral Code" style={themeManager.getLabelStyles()} />
      <div
        className="q_refer_code_box"
        style={themeManager.getReferralCodeStyles().container}
      >
        <div
          className="q_refer_code"
          style={themeManager.getReferralCodeStyles().text}
        >
          {referralCode}
        </div>
        <img
          className="q_refer_copy_icon"
          src={
            copy[0]
              ? tickIcon(styleConfig?.Icon?.color)
              : copyIcon(secondaryIconColor)
          }
          onClick={() => handleCopy(0)}
          alt=""
          style={{...themeManager.getIconStyles(),background:"none"}}
        />
      </div>
    </div>
  );

  const renderReferralLinkSection = () => (
    <div className="q_refer_code_content">
      <Label children="Invitation Link" style={themeManager.getLabelStyles()} />
      <div
        className="q_refer_code_box"
        style={themeManager.getReferralCodeStyles().container}
      >
        <div
          className="q_refer_code"
          style={themeManager.getReferralCodeStyles().text}
        >
          {referralLink}
          {referralCode}
        </div>
        <img
          className="q_refer_copy_icon"
          src={
            copy[1]
              ? tickIcon(styleConfig?.Icon?.color)
              : copyIcon(secondaryIconColor)
          }
          onClick={() => handleCopy(1)}
          alt=""
          style={{ ...themeManager.getIconStyles(), background: "none" }}
        />
      </div>
    </div>
  );

  const renderSocialLinks = () => (
    <div className="q_social_links">
      <div
        className="q_social_link_icon"
        style={themeManager.getIconStyles()}
        onClick={() => handleSocialShare("linkedin")}
      >
        <LinkedIn color={extractGradientColors(styleConfig?.Icon?.color || brandTheme?.primaryColor || QuestThemeData?.accentColor || '#0065FF')} />
      </div>
      <div
        className="q_social_link_icon"
        style={themeManager.getIconStyles()}
        onClick={() => handleSocialShare("facebook")}
      >
        <Facebook color={extractGradientColors(styleConfig?.Icon?.color || brandTheme?.primaryColor || QuestThemeData?.accentColor || '#0065FF')} />
      </div>
      <div
        className="q_social_link_icon"
        style={themeManager.getIconStyles()}
        onClick={() => handleSocialShare("x")}
      >
        <Twitter color={extractGradientColors(styleConfig?.Icon?.color || brandTheme?.primaryColor || QuestThemeData?.accentColor || '#0065FF')} />
      </div>
    </div>
  );

  const renderMainContent = () => (
    <div
      className="q_refer_and_earn"
      style={themeManager.getMainContentStyles()}
    >
      {showReferralLogo && (
        <div className="q_refer_head">
          <ReferIcon primary={themeManager.getReferIconColors().primary} secondary={themeManager.getReferIconColors().secondary} />
        </div>
      )}

      <div className="q_refer_content">
        <div className="refer_content_box">
          <div
            className="q_refer_heading"
            style={themeManager.getHeadingStyles()}
          >
            {heading}
          </div>
          <div
            className="q_refer_desc"
            style={themeManager.getDescriptionStyles()}
          >
            {description}
          </div>
        </div>

        {showReferralCode && renderReferralCodeSection()}
        {referralLink && renderReferralLinkSection()}

        <PrimaryButton
          children={shareButtonText}
          style={themeManager.getPrimaryButtonStyles()}
          onClick={() => handleCopy(1)}
          type="button"
        />

        {renderSocialLinks()}
      </div>

      {!gradientBackground && showFooter && (
        <QuestLabs
          style={themeManager.getFooterStyles().container}
          textStyle={themeManager.getFooterStyles().text}
          iconStyle={themeManager.getFooterStyles().icon}
          text={themeManager.getFooterStyles().content.text}
          link={footerLink}
        />
      )}
    </div>
  );

  if (gradientBackground) {
    return (
      <div style={themeManager.getGradientWrapperStyles()}>
        <div
          className="q_gradient_background"
          style={themeManager.getGradientContainerStyles(gradientBackgroundColor)}
        >
          <div className="q_gradient_head">
            <div
              className="q_gradient_heading"
              style={themeManager.getGradientHeadingStyles()}
            >
              {primaryHeading}
            </div>
            <div
              className="q_gradient_description"
              style={themeManager.getGradientDescriptionStyles()}
            >
              {primaryDescription}
            </div>
          </div>
          {renderMainContent()}
          <div className="q_gradient_quest_powered">
            {showFooter && (
              <QuestLabs
                style={themeManager.getFooterStyles().container}
                textStyle={themeManager.getFooterStyles().text}
                iconStyle={themeManager.getFooterStyles().icon}
                text={themeManager.getFooterStyles().content.text}
                link={footerLink}
              />
            )}
          </div>
        </div>
      </div>
    );
  }

  return renderMainContent();
};

export default OfflineReferEarnWrapper;